export default {"src":"/_next/static/media/line.3865e4ce.svg","height":71,"width":565};